<template>
    <div class="order bg_white">
        <div class="header">
            <div class="filter">
                <div class="fl f14 bold400 txt_black85">
                    <span class="fl">状态：</span>
                    <selection class="select fl" :options="$config.invoiceStatus.getItem(2)" @change="statusChange"></selection>
                </div>
            </div>
        </div>
        <lists ref="lists" :data="lists" :listsStyle="listsStyle" :httpRequestData="httpRequestData" @doneEvent="doneEvent" @detailEvent="detailEvent"></lists>
        <detail ref="detail"></detail>
    </div>
</template>

<script>
    import Lists from '@/components/Lists'
    import Detail from './detail'

    export default {
        name: "invoice",
        components: {
            Lists, Detail
        },
        data() {
            return {
                lists: {
                    title: [{text: '用户名称'}, {text: '申请时间'}, {text: '金额'}, {text: '开过票的金额'}, {text: '类型'}, {text: '状态'}, {text: '操作'}]
                },
                listsStyle: [
                    {width: '20%', textAlign: 'left'},
                    {width: '15%', textAlign: 'left'},
                    {width: '10%', textAlign: 'left'},
                    {width: '10%', textAlign: 'left'},
                    {width: '10%', textAlign: 'left'},
                    {width: '10%', textAlign: 'left'},
                    {width: '15%', textAlign: 'left'},
                ],
                httpRequestData: {
                    url: '/manage/invoice',
                    func: this.httpRequestHandle,
                    error: '获取发票信息出错',
                    auto: false
                }
            }
        },
        methods: {
            init() {
                this.$refs.lists.updateData();
            },
            httpRequestHandle(data) {
                let operation = {
                    arr: [
                        {text: '完成', style: {color: '#1890FF'}, event: 'doneEvent'},
                        {text: '详情', style: {color: '#1890FF'}, event: 'detailEvent'},
                    ]
                };
                return data.map(item =>{
                    return [
                        {text: item.user},
                        {text: item.time},
                        {text: item.price},
                        {text: item.priced},
                        {text: this.$config.invoiceType.get(item.content.type)},
                        {text: this.$config.invoiceStatus.get(item.status)},
                        operation
                    ]
                });
            },
            statusChange(data) {
                let filter = !data ? {} : {status: data.id};
                this.$refs.lists.updateData(filter);
            },
            detailEvent(data) {
                this.$refs.detail.init(data.content,data.price)
            },
            doneEvent(data) {
                if(data.status === 1) {
                    this.$modal({content: '该申请已完成，不可重复操作'});
                    return;
                }
                this.$modal({
                    content: '确定该申请已完成，此操作不可撤销',
                    confirm: ()=>{
                        this.$api.put('/manage/invoice/' + data.id,{
                            status: 1
                        }).then((data) => {
                            this.$alert.success({content: '修改成功'});
                            this.$refs.lists.updateData();
                        }).catch((error) => {
                            this.$alert.error({content: '修改失败，请重试'});
                        });
                    }
                });
            }
        }
    }
</script>

<style scoped>
    .order{
        min-width: 1400px !important;
        padding: 0 5px;
    }
    .order>.header{
        height: 80px;
    }
    .filter>div{
        height: 36px;
        line-height: 36px;
        margin: 22px 0 0 20px;
    }
    .filter>div>input{
        width: 220px;
        border: 1px solid rgba(204, 204, 204, 1);
        border-radius: 3px;
        height: 34px;
        line-height: 34px;
    }
    .filter>div>.select{
        width: 220px;
        border-radius: 3px;
        height: 36px;
        line-height: 36px;
    }
</style>
